import React from "react";

export const GrandTotalLabel: React.FC = () => <div style={{ display: "flex", alignItems: "center", height: "100%" }}>Overall cost</div>;
